import { CommonModule, NgIf } from '@angular/common';
import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { Router } from '@angular/router';
import { EventInteractionService } from '@mare-common/ngx-mare-common';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { ComponentIdentityReportComponent } from '../component-identity-report/component-identity-report.component';

@Component({
  selector: 'company-data-error',
  templateUrl: './company-data-error.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatButtonModule,
    ComponentIdentityReportComponent
  ],
  styleUrls: ['./company-data-error.component.scss']
})
export class CompanyDataErrorComponent implements OnInit {

  @Input() errors?: Array<string>;
  @Input() title?: string;
  @Input() message?: string;
  @Input() actions?: Array<any>;
  @Input() company?: any;
  @Input() piva?: string;
  // translate in english "Contatta gratuitamente un consulente per maggiori informazioni"

  buttonlabelchat!:string;

  constructor(private router: Router,
    private eventInteractionService: EventInteractionService,
    private translateService: TranslateService
  ) {
// translateService.setDefaultLang('it');
//     translateService.use('it');
    translateService.get('Contact a consultant for free').subscribe((res) => {
      if (res) {
        this.buttonlabelchat = res;
      }
    })

   }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    
  }
  ngOnChanges(changes: SimpleChanges): void {

    if (changes['errors'] && changes['errors'].currentValue) {
      this.errors = changes['errors'].currentValue;
    }
    if (changes['title'] && changes['title'].currentValue) {

      this.title = changes['title'].currentValue;
    }
    if (changes['message'] && changes['message'].currentValue) {
        
      this.message = changes['message'].currentValue;
    }
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    
  }
  goToMarketplace() {
    console.log('go to marketplace flow');
    this.router.navigate([environment.routingBasePath + '/marketplace'])
  }

  goContactAssistance() {
    this.eventInteractionService.publishData({ event: 'openAssistanceForm' });
  }
}
